module.exports = __webpack_public_path__ + "img/en-US.f7201f08.svg";